import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';
import './styles/global.css';

// Static-site generation entry. `vite-react-ssg build` pre-renders every route
// to complete HTML (great for search engines, AI crawlers and no-JS clients),
// then React hydrates for interactivity in the browser.
export const createRoot = ViteReactSSG({ routes });

// Only the marketing pages are pre-rendered (the landing page must stay fully
// indexable with no backend). The app under /app is a client-side product
// surface on dummy data — exclude it from SSG. Note: vite-react-ssg flattens
// route paths without a leading slash ("app", "app/documents", ...).
export function includedRoutes(paths: string[]): string[] {
  return paths.filter((p) => {
    const clean = p.replace(/^\//, '');
    return clean !== 'app' && !clean.startsWith('app/');
  });
}
